var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{ 'slide-up': _vm.revealIcon, 'slide-out': !_vm.revealIcon,'product-icon-reveal': !_vm.isWall, 'product-icon-reveal-touchscreen': _vm.isWall },style:({
    top: _vm.productIcon.position.top + '%',
    left: _vm.productIcon.position.left + '%',
    transitionDelay: _vm.productIcon.delay + 's'
  })},[_c('img',{staticClass:"product-icon-reveal__img",attrs:{"src":_vm.getIcon(_vm.productIcon.icon),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }